import { Textarea, FormGroup } from '@bigcommerce/big-design';

export default function OrderComments(props) {
	const { customer, setCustomerInformation } = props;

	return (
		<FormGroup marginTop="xxxLarge">
			<Textarea
				required
				label="Order Comments"
				placeholder="Enter order comments"
				rows={3}
				resize={true}
				value={customer?.order_comments ?? ''}
				onChange={(e) =>
					setCustomerInformation('order_comments', e.target.value)
				}
			/>
		</FormGroup>
	);
}
